import { render, staticRenderFns } from "./AdjustDoases.vue?vue&type=template&id=5cc9dde6&scoped=true"
import script from "./AdjustDoases.vue?vue&type=script&lang=js"
export * from "./AdjustDoases.vue?vue&type=script&lang=js"
import style0 from "./AdjustDoases.vue?vue&type=style&index=0&id=5cc9dde6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc9dde6",
  null
  
)

export default component.exports